import { render, staticRenderFns } from "./userPosts.vue?vue&type=template&id=718e42ca&"
import script from "./userPosts.vue?vue&type=script&lang=js&"
export * from "./userPosts.vue?vue&type=script&lang=js&"
import style0 from "./userPosts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports